export enum AuthStatus {
    UNAUTHENTICATED = 'UNAUTHENTICATED',
    PASSWORD_VERIFIED = 'PASSWORD_VERIFIED',
    LOGIN = 'LOGIN',
}
